import React from 'react';
import VolunteerHub from '../volunteer/VolunteerHub';

interface MemberVolunteerProps {
    memberData?: any;
}

const MemberVolunteer: React.FC<MemberVolunteerProps> = ({ memberData }) => {
    const memberId = memberData?.id || 'member-id-placeholder';

    return (
        <div className="min-h-screen bg-gray-50">
            <VolunteerHub memberId={memberId} />
        </div>
    );
};

export default MemberVolunteer;